
// import React, { useEffect, useState, useRef } from 'react';
// import axios from "../../api/axiosAuth";

// import io from 'socket.io-client';
// import '../../style/MatriculaForm.css';
// import { useAuth } from '../../context/AuthContext';

// const API_BASE = process.env.REACT_APP_API_MATRICULAS || 'http://localhost:5001/api/matriculas';
// const API_SEDES = process.env.REACT_APP_API_SEDES || 'http://localhost:5001/api/sedes';

// const TIPO_DOCUMENTO_OPTIONS = ['Cédula', 'Tarjeta de identidad', 'Registro civil', 'Pasaporte', 'Cédula de extranjería', 'Otro'];
// const TIPO_SANGRE_OPTIONS = ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'];
// const GENERO_OPTIONS = ['Masculino', 'Femenino', 'Otro'];
// const ESTRATO_OPTIONS = ['1', '2', '3', '4', '5', '6'];
// const JORNADAS = ['MAÑANA', 'TARDE'];

// function MatriculaForm() {
//   const { token } = useAuth();
//   const [sedes, setSedes] = useState([]);
//   const [matriculas, setMatriculas] = useState([]);
//   const [matriculaExistente, setMatriculaExistente] = useState(false);
//   const [mensaje, setMensaje] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [gradoSeleccionado, setGradoSeleccionado] = useState('');
//   const [showTabla, setShowTabla] = useState(false); // ✅ Corregido
//   const socketRef = useRef(null);
//   const fotoPreviewUrlRef = useRef(null);

//   const [formData, setFormData] = useState({
//     documento_estudiante: '', tipo_documento: '', nombres_estudiante: '', apellidos_estudiante: '',
//     fecha_nacimiento_estudiante: '', telefono_estudiante: '', eps: '', grado: '', grupo: '',
//     sede_id: '', jornada: '', numero_matricula: '', codigo_anterior: '', fecha_matricula: '',
//     tipo_sangre: '', direccion_estudiante: '', email_estudiante: '', estrato: '', genero: '',
//     documento_padre: '', tipo_documento_padre: '', nombres_padre: '', apellidos_padre: '',
//     fecha_nacimiento_padre: '', telefono1: '', telefono2: '', direccion_padre: '', ocupacion_padre: '', parentesco: ''
//   });

//   const [files, setFiles] = useState({
//     documento_estudiante_archivo: null, documento_representante: null, sirben: null, fosyga: null,
//     boletin_anterior: null, foto_estudiante: null, servicios_publicos: null, paz_y_salvo: null
//   });

//   const getAuthHeaders = () => token ? { Authorization: `Bearer ${token}` } : {};

//   // FETCH SEDES
//   const fetchSedes = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(API_SEDES, { headers: getAuthHeaders() });
//       const sedesData = Array.isArray(res.data) ? res.data : res.data?.data || [];
//       setSedes(sedesData);
//     } catch (err) {
//       console.warn(err);
//       setSedes([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // FETCH MATRICULAS
//   // const fetchMatriculas = async () => {
//   //   try {
//   //     setLoading(true);
//   //     const res = await axios.get(API_BASE, { headers: getAuthHeaders() });
//   //     const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
//   //     setMatriculas(data);
//   //   } catch (err) {
//   //     console.error(err);
//   //     setError('Error cargando matrículas');
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
// const fetchMatriculas = async (sedeId = '') => {
//   try {
//     setLoading(true);
//     setError('');
//     setMensaje('');

//     // Construimos la URL con query param para filtrar por sede si se indica
//     const url = sedeId
//       ? `${API_BASE}?sede_id=${encodeURIComponent(sedeId)}`
//       : `${API_BASE}?sede_id=0`; // 0 para traer también el tenant principal

//     const res = await axios.get(url, { headers: getAuthHeaders() });

//     // Normalizamos la data
//     const data = Array.isArray(res.data) ? res.data : res.data?.data || [];

//     // Aseguramos que si es del tenant principal se muestre el nombre del tenant
//     const processed = data.map(m => ({
//       ...m,
//       sede_nombre: m.sede_id && m.sede_nombre ? m.sede_nombre : m.tenant_nombre
//     }));

//     setMatriculas(processed);

//   } catch (err) {
//     console.error(err);
//     setError('Error cargando matrículas');
//     setMatriculas([]);
//   } finally {
//     setLoading(false);
//   }
// };

//   // USE EFFECT
//   useEffect(() => {
//     const loadInitialData = async () => {
//       await fetchSedes();
//       await fetchMatriculas();
//     };

//     loadInitialData();

//     try {
//       socketRef.current = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:5001', {
//         auth: token ? { token } : {}
//       });
//       socketRef.current.on('nueva_matricula', fetchMatriculas);
//       socketRef.current.on('eliminar_matricula', fetchMatriculas);
//     } catch (e) {
//       console.warn('Error al conectar socket:', e);
//     }

//     return () => {
//       socketRef.current?.disconnect();
//       if (fotoPreviewUrlRef.current) {
//         URL.revokeObjectURL(fotoPreviewUrlRef.current);
//         fotoPreviewUrlRef.current = null;
//       }
//     };
//   }, [token]);

//   // Auto-seleccionar sede principal
//   useEffect(() => {
//     if (sedes.length > 0) {
//       const principal = sedes.find(s => s.es_principal === 1 || s.es_principal === true);
//       if (principal) {
//         setFormData(prev => ({ ...prev, sede_id: String(principal.id) }));
//       }
//     }
//   }, [sedes]);

//   // SAFE SET FORM FROM BACKEND
//   const safeSetFormFromBackend = (data = {}) => {
//     const estudiante = data.estudiante || data || {};
//     const padre = data.padre || {};
//     setFormData(prev => ({
//       ...prev,
//       documento_estudiante: estudiante.documento_estudiante ?? estudiante.documento ?? prev.documento_estudiante,
//       tipo_documento: estudiante.tipo_documento ?? prev.tipo_documento,
//       nombres_estudiante: estudiante.nombres_estudiante ?? estudiante.nombres ?? prev.nombres_estudiante,
//       apellidos_estudiante: estudiante.apellidos_estudiante ?? estudiante.apellidos ?? prev.apellidos_estudiante,
//       fecha_nacimiento_estudiante: estudiante.fecha_nacimiento_estudiante ?? estudiante.fecha_nacimiento ?? prev.fecha_nacimiento_estudiante,
//       telefono_estudiante: estudiante.telefono_estudiante ?? estudiante.telefono ?? prev.telefono_estudiante,
//       eps: estudiante.eps ?? prev.eps,
//       grado: estudiante.grado ?? prev.grado,
//       grupo: estudiante.grupo ?? prev.grupo,
//       sede_id: estudiante.sede_id ?? estudiante.sede ?? prev.sede_id,
//       jornada: estudiante.jornada ?? prev.jornada,
//       numero_matricula: estudiante.numero_matricula ?? prev.numero_matricula,
//       codigo_anterior: estudiante.codigo_anterior ?? prev.codigo_anterior,
//       fecha_matricula: estudiante.fecha_matricula ?? prev.fecha_matricula,
//       tipo_sangre: estudiante.tipo_sangre ?? prev.tipo_sangre,
//       direccion_estudiante: estudiante.direccion_estudiante ?? estudiante.direccion ?? prev.direccion_estudiante,
//       email_estudiante: estudiante.email_estudiante ?? estudiante.email ?? prev.email_estudiante,
//       estrato: estudiante.estrato ?? prev.estrato,
//       genero: estudiante.genero ?? prev.genero,
//       documento_padre: padre.documento_padre ?? padre.documento ?? prev.documento_padre,
//       tipo_documento_padre: padre.tipo_documento ?? prev.tipo_documento_padre,
//       nombres_padre: padre.nombres ?? padre.nombres_padre ?? prev.nombres_padre,
//       apellidos_padre: padre.apellidos ?? padre.apellidos_padre ?? prev.apellidos_padre,
//       fecha_nacimiento_padre: padre.fecha_nacimiento ?? prev.fecha_nacimiento_padre,
//       telefono1: padre.telefono1 ?? padre.telefono ?? prev.telefono1,
//       telefono2: padre.telefono2 ?? prev.telefono2,
//       direccion_padre: padre.direccion ?? prev.direccion_padre,
//       ocupacion_padre: padre.ocupacion_padre ?? prev.ocupacion_padre,
//       parentesco: padre.parentesco ?? prev.parentesco
//     }));
//   };

//   // HANDLERS
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'grado') { 
//       setGradoSeleccionado(value); 
//       setFormData(prev => ({ ...prev, grado: value })); 
//       return; 
//     }
//     if (name === 'grupo') { 
//       setFormData(prev => ({ ...prev, grupo: value.toUpperCase().slice(0, 1) })); 
//       return; 
//     }
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = (e) => {
//     const { name, files: f } = e.target;
//     const file = f?.[0] || null;
//     setFiles(prev => ({ ...prev, [name]: file }));
//     if (name === 'foto_estudiante') {
//       if (fotoPreviewUrlRef.current) URL.revokeObjectURL(fotoPreviewUrlRef.current);
//       if (file) fotoPreviewUrlRef.current = URL.createObjectURL(file);
//     }
//   };

//   const validateBeforeSubmit = () => {
//     const requiredFields = [
//       'documento_estudiante', 'nombres_estudiante', 'apellidos_estudiante', 
//       'tipo_documento', 'fecha_nacimiento_estudiante', 'grado', 'grupo',
//       'sede_id', 'jornada', 'documento_padre'
//     ];
//     for (const f of requiredFields) {
//       if (!formData[f]?.toString().trim()) return `El campo ${f.replace(/_/g,' ')} es obligatorio`;
//     }
//     const requiredFiles = ['documento_estudiante_archivo', 'documento_representante'];
//     for (const f of requiredFiles) {
//       if (!files[f]) return `El archivo ${f.replace(/_/g,' ')} es obligatorio`;
//     }
//     return null;
//   };

//   const handleBuscar = async () => {
//     setError(''); setMensaje('');
//     const doc = String(formData.documento_estudiante || '').trim();
//     if (!doc) { setError('Ingresa un documento para buscar'); return; }
//     try {
//       setLoading(true);
//       const res = await axios.get(`${API_BASE}/${encodeURIComponent(doc)}`, { headers: getAuthHeaders() });
//       safeSetFormFromBackend(res.data);
//       setGradoSeleccionado(res.data?.grado ?? res.data?.estudiante?.grado ?? '');
//       setMatriculaExistente(true);
//       setMensaje('✅ Matrícula encontrada y cargada');
//     } catch {
//       setMatriculaExistente(false);
//       setMensaje('⚠️ Matrícula no encontrada. Complete los datos para registrar.');
//     } finally { setLoading(false); }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault(); setError(''); setMensaje('');
//     const validationError = validateBeforeSubmit();
//     if (validationError) { setError(validationError); return; }

//     const payload = new FormData();
//     Object.entries(formData).forEach(([k, v]) => payload.append(k, v ?? ''));
//     Object.entries(files).forEach(([k, f]) => { if (f) payload.append(k, f); });

//     try {
//       setSaving(true);
//       const doc = String(formData.documento_estudiante || '').trim();
//       const url = matriculaExistente ? `${API_BASE}/${encodeURIComponent(doc)}` : API_BASE;
//       const method = matriculaExistente ? 'put' : 'post';
//       const res = await axios({ method, url, data: payload, headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' } });
//       setMensaje(res.data?.message || (matriculaExistente ? '✅ Matrícula actualizada' : '✅ Matrícula guardada con éxito'));
//       setMatriculaExistente(true);
//       fetchMatriculas();
//     } catch (err) { setError(err?.response?.data?.message || '❌ Error guardando matrícula'); }
//     finally { setSaving(false); }
//   };

//   const handleEliminar = async () => {
//     const doc = String(formData.documento_estudiante || '').trim();
//     if (!doc) { setError('Documento obligatorio'); return; }
//     if (!window.confirm('¿Deseas eliminar esta matrícula?')) return;
//     try { 
//       setSaving(true); 
//       await axios.delete(`${API_BASE}/${encodeURIComponent(doc)}`, { headers: getAuthHeaders() }); 
//       setMensaje('🗑️ Matrícula eliminada correctamente'); 
//       setMatriculaExistente(false); 
//       fetchMatriculas(); 
//     } catch (err) { setError(err?.response?.data?.message || '❌ Error al eliminar matrícula'); } 
//     finally { setSaving(false); }
//   };

//   const calcularEdad = (fecha) => { 
//     if (!fecha) return ''; 
//     const f = new Date(fecha); 
//     if (isNaN(f)) return ''; 
//     const hoy = new Date(); 
//     let edad = hoy.getFullYear() - f.getFullYear(); 
//     const mes = hoy.getMonth() - f.getMonth(); 
//     if (mes < 0 || (mes === 0 && hoy.getDate() < f.getDate())) edad--; 
//     return edad; 
//   };

//   const getSedeNombre = (id) => { 
//     const s = sedes.find(x => String(x.id) === String(id)); 
//     return s ? s.nombre : ''; 
//   };

//   // ===============================
//   // Render: Formulario completo + tabla
//   // ===============================

// const { user } = useAuth();
// const tenantNombre = user?.institucion_nombre || "Colegio";


//   // ===== Render =====
//   return (
//     <div className="matricula-wrap">
//       <form className="mat-form" onSubmit={handleSubmit} encType="multipart/form-data">
//         <header className="mat-header">
//           <h2>Matrícula</h2>
//           <div className="mat-actions">
//             <button type="button" className="btn-primary" onClick={() => {
//               setFormData({ documento_estudiante: '', tipo_documento: '', nombres_estudiante: '', apellidos_estudiante: '',
//                 fecha_nacimiento_estudiante: '', telefono_estudiante: '', eps: '', grado_id: '', grupo_id: '',
//                 sede_id: '', jornada: '', numero_matricula: '', codigo_anterior: '', fecha_matricula: '',
//                 tipo_sangre: '', direccion_estudiante: '', email_estudiante: '', estrato: '', genero: '',
//                 documento_padre: '', tipo_documento_padre: '', nombres_padre: '', apellidos_padre: '',
//                 fecha_nacimiento_padre: '', telefono1: '', telefono2: '', direccion_padre: '',
//                 ocupacion_padre: '', parentesco: ''
//               });
//               setFiles({ documento_estudiante_archivo: null, documento_representante: null, sirben: null, fosyga: null,
//                 boletin_anterior: null, foto_estudiante: null, servicios_publicos: null, paz_y_salvo: null });
//               setMatriculaExistente(false); setGradoSeleccionado(''); setMensaje(''); setError('');
//               if (fotoPreviewUrlRef.current) { URL.revokeObjectURL(fotoPreviewUrlRef.current); fotoPreviewUrlRef.current = null; }
//             }}>+ Nueva</button>

//             <button type="button" className="btn-outline" onClick={() => { setShowTabla(!showTabla); if (!showTabla) fetchMatriculas(); }}>
//               {showTabla ? 'Ocultar matriculados' : 'Mostrar matriculados'}
//             </button>
//           </div>
//         </header>

//         {/* Documento + buscar */}
//         <div className="row">
//           <label>Documento del estudiante</label>
//           <div className="row-inline">
//             <input name="documento_estudiante" value={formData.documento_estudiante || ''} onChange={handleChange} placeholder="Número de documento" />
//             <button type="button" className="btn-search" onClick={handleBuscar} disabled={loading}>
//               {loading ? 'Buscando...' : 'Buscar'}
//             </button>
//           </div>
//         </div>

//         {/* Datos estudiante */}
//         <div className="row grid-3">
//           <div>
//             <label>Nombres</label>
//             <input name="nombres_estudiante" value={formData.nombres_estudiante || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Apellidos</label>
//             <input name="apellidos_estudiante" value={formData.apellidos_estudiante || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Tipo documento</label>
//             <select name="tipo_documento" value={formData.tipo_documento || ''} onChange={handleChange}>
//               <option value="">Seleccione</option>
//               {TIPO_DOCUMENTO_OPTIONS.map(t => <option key={t} value={t}>{t}</option>)}
//             </select>
//           </div>
//         </div>

//         <div className="row grid-3">
//           <div>
//             <label>Fecha nacimiento</label>
//             <input type="date" name="fecha_nacimiento_estudiante" value={formData.fecha_nacimiento_estudiante || ''} onChange={handleChange} />
//             {formData.fecha_nacimiento_estudiante && <small>Edad: {calcularEdad(formData.fecha_nacimiento_estudiante)} años</small>}
//           </div>
//           <div>
//             <label>Teléfono</label>
//             <input name="telefono_estudiante" value={formData.telefono_estudiante || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>EPS</label>
//             <input name="eps" value={formData.eps || ''} onChange={handleChange} />
//           </div>
//         </div>

//         <div className="row grid-3">
//           <div>
//             <label>Dirección</label>
//             <input name="direccion_estudiante" value={formData.direccion_estudiante || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Email</label>
//             <input type="email" name="email_estudiante" value={formData.email_estudiante || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Estrato</label>
//             <select name="estrato" value={formData.estrato || ''} onChange={handleChange}>
//               <option value="">Seleccione</option>
//               {ESTRATO_OPTIONS.map(e => <option key={e} value={e}>{e}</option>)}
//             </select>
//           </div>
//         </div>

//         <div className="row grid-3">
//           <div>
//             <label>Tipo de sangre</label>
//             <select name="tipo_sangre" value={formData.tipo_sangre || ''} onChange={handleChange}>
//               <option value="">Seleccione</option>
//               {TIPO_SANGRE_OPTIONS.map(t => <option key={t} value={t}>{t}</option>)}
//             </select>
//           </div>
//           <div>
//             <label>Género</label>
//             <select name="genero" value={formData.genero || ''} onChange={handleChange}>
//               <option value="">Seleccione</option>
//               {GENERO_OPTIONS.map(g => <option key={g} value={g}>{g}</option>)}
//             </select>
//           </div>
//           <div>
//             <label>Grado</label>
//          <select
//   name="grado"
//   value={formData.grado || ''}
//   onChange={(e) => {
//     const val = e.target.value;
//     setFormData(prev => ({ ...prev, grado: val ? Number(val) : '' }));
//     setGradoSeleccionado(val ? Number(val) : '');
//   }}
// >
//   <option value="">Seleccione</option>
//   {/* Grados del 1 al 11 */}
//   {[1,2,3,4,5,6,7,8,9,10,11].map(g => (
//     <option key={g} value={g}>{g}°</option>
//   ))}
// </select>

//           </div>
//         </div>

//         <div className="row grid-3">
//           <div>
//             <label>Grupo</label>
//            <input
//   name="grupo"
//   value={formData.grupo || ''}
//   onChange={handleChange}
//   maxLength={1}
// />

//           </div>

// <div>
//   <label>Sede</label>
//   <select
//     name="sede_id"
//     value={String(formData.sede_id ?? "")}
//     onChange={handleChange}
//   >
//     <option value="">Seleccione</option>

//     {/* Colegio principal */}
//     <option value="0">
//       {tenantNombre} (Principal)
//     </option>

//     {/* Sedes */}
//     {sedes.map(s => (
//       <option key={s.id} value={String(s.id)}>
//         {s.nombre}
//       </option>
//     ))}
//   </select>
// </div>






//           <div>
//             <label>Jornada</label>
//             <select name="jornada" value={formData.jornada || ''} onChange={handleChange}>
//               <option value="">Seleccione</option>
//               {JORNADAS.map(j => <option key={j} value={j}>{j}</option>)}
//             </select>
//           </div>
//         </div>

//         <div className="row grid-3">
//           <div>
//             <label>Código anterior</label>
//             <input name="codigo_anterior" value={formData.codigo_anterior || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Fecha matrícula</label>
//             <input type="date" name="fecha_matricula" value={formData.fecha_matricula || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Número matrícula</label>
//             <input name="numero_matricula" value={formData.numero_matricula || ''} onChange={handleChange} />
//           </div>
//         </div>

//         {/* Archivos */}
//         <div className="row grid-2">
//           <div>
//             <label>Documento Estudiante</label>
//             <input type="file" name="documento_estudiante_archivo" onChange={handleFileChange} accept="image/*,.pdf" />
//           </div>

//           <div>
//             <label>Foto Estudiante</label>
//             <input type="file" name="foto_estudiante" onChange={handleFileChange} accept="image/*" />
//             {files.foto_estudiante && fotoPreviewUrlRef.current && (
//               <img src={fotoPreviewUrlRef.current} alt="Preview" className="foto-preview" />
//             )}
//           </div>
//         </div>

//         <div className="row grid-2">
//           <div>
//             <label>Documento del Representante</label>
//             <input type="file" name="documento_representante" onChange={handleFileChange} accept="image/*,.pdf" />
//           </div>
//           <div>
//             <label>Servicios públicos</label>
//             <input type="file" name="servicios_publicos" onChange={handleFileChange} accept="image/*,.pdf" />
//           </div>
//         </div>

//         <div className="row grid-2">
//           <div>
//             <label>SISBEN </label>
//             <input type="file" name="sirben" onChange={handleFileChange} accept="image/*,.pdf" />
//           </div>
//           <div>
//             <label>FOSYGA</label>
//             <input type="file" name="fosyga" onChange={handleFileChange} accept="image/*,.pdf" />
//           </div>
//         </div>

//         <div className="row grid-2">
//           <div>
//             <label>Boletín anterior</label>
//             <input type="file" name="boletin_anterior" onChange={handleFileChange} accept="image/*,.pdf" />
//           </div>
//           <div>
//             <label>Paz y Salvo</label>
//             <input type="file" name="paz_y_salvo" onChange={handleFileChange} accept="image/*,.pdf" />
//           </div>
//         </div>

//         {/* Acudiente */}
//         <h3>Datos del Acudiente</h3>
//         <div className="row grid-3">
//           <div>
//             <label>Documento acudiente</label>
//             <input name="documento_padre" value={formData.documento_padre || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Tipo documento acudiente</label>
//             <select name="tipo_documento_padre" value={formData.tipo_documento_padre || ''} onChange={handleChange}>
//               <option value="">Seleccione</option>
//               {TIPO_DOCUMENTO_OPTIONS.map(t => <option key={t} value={t}>{t}</option>)}
//             </select>
//           </div>
//           <div>
//             <label>Nombres acudiente</label>
//             <input name="nombres_padre" value={formData.nombres_padre || ''} onChange={handleChange} />
//           </div>
//         </div>

//         <div className="row grid-3">
//           <div>
//             <label>Apellidos acudiente</label>
//             <input name="apellidos_padre" value={formData.apellidos_padre || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Fecha nacimiento acudiente</label>
//             <input type="date" name="fecha_nacimiento_padre" value={formData.fecha_nacimiento_padre || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Teléfono 1</label>
//             <input name="telefono1" value={formData.telefono1 || ''} onChange={handleChange} />
//           </div>
//         </div>

//         <div className="row grid-3">
//           <div>
//             <label>Teléfono 2</label>
//             <input name="telefono2" value={formData.telefono2 || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Dirección acudiente</label>
//             <input name="direccion_padre" value={formData.direccion_padre || ''} onChange={handleChange} />
//           </div>
//           <div>
//             <label>Ocupación</label>
//             <input name="ocupacion_padre" value={formData.ocupacion_padre || ''} onChange={handleChange} />
//           </div>
//         </div>

//         <div className="row">
//           <label>Parentesco</label>
//           <input name="parentesco" value={formData.parentesco || ''} onChange={handleChange} />
//         </div>

//         {error && <p className="msg error">{error}</p>}
//         {mensaje && <p className="msg success">{mensaje}</p>}

//         <div className="btn-group">
//           <button type="submit" className="btn-primary" disabled={saving}>
//             {saving ? (matriculaExistente ? 'Actualizando...' : 'Registrando...') : (matriculaExistente ? 'Actualizar matrícula' : 'Registrar matrícula')}
//           </button>
//           {matriculaExistente && <button type="button" className="btn-danger" onClick={handleEliminar} disabled={saving}>Eliminar matrícula</button>}
//         </div>
//       </form>

//       {/* Tabla */}
//       {showTabla && (
//         <div className="tabla-matriculados">
//           <h3>Estudiantes matriculados ({matriculas.length})</h3>
//           <table>
//             <thead>
//               <tr>
//                 <th>Documento</th>
//                 <th>Nombre</th>
//                 <th>Grado</th>
//                 <th>Grupo</th>
//                 <th>Sede</th>
//                 <th>Acción</th>
//               </tr>
//             </thead>
//             <tbody>
//               {matriculas.length === 0 ? (
//                 <tr><td colSpan="6" style={{ textAlign: 'center' }}>No hay datos</td></tr>
//               ) : (
//                 matriculas.map((m, i) => (
//                   <tr key={m.documento_estudiante || m.id || i}>
//                     <td>{m.documento_estudiante}</td>
//                     <td>{(m.nombres_estudiante || m.nombres || '') + ' ' + (m.apellidos_estudiante || m.apellidos || '')}</td>
//                     <td>{m.grado || m.grado_id || ''}</td>
//                     <td>{m.grupo || m.grupo_id || ''}</td>
//                     <td>{m.sede_nombre || getSedeNombre(m.sede_id) || ''}</td>
//                     <td>
//                       <button className="btn-load" onClick={() => {
//                         safeSetFormFromBackend(m);
//                         setMatriculaExistente(true);
//                         setGradoSeleccionado(String(m.grado_id ?? m.grado ?? ''));
//                         window.scrollTo({ top: 0, behavior: 'smooth' });
//                       }}>Cargar</button>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }

// export default MatriculaForm;


//
import React, { useEffect, useState, useRef, useMemo } from 'react';
import axios from "../../api/axiosAuth";
import io from 'socket.io-client';
import { useAuth } from '../../context/AuthContext';
import { API } from "../config"; // ✅ Importación solicitada
import '../../style/MatriculaForm.css';

// Configuración de endpoints basada en la API centralizada
const API_BASE = `${API}/matriculas`;
const API_SEDES = `${API}/sedes`;

// Opciones constantes
const TIPO_DOCUMENTO_OPTIONS = ['Cédula', 'Tarjeta de identidad', 'Registro civil', 'Pasaporte', 'Cédula de extranjería', 'Otro'];
const TIPO_SANGRE_OPTIONS = ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'];
const GENERO_OPTIONS = ['Masculino', 'Femenino', 'Otro'];
const ESTRATO_OPTIONS = ['1', '2', '3', '4', '5', '6'];
const JORNADAS = ['MAÑANA', 'TARDE'];

function MatriculaForm() {
  const { token, user } = useAuth();
  const tenantNombre = user?.institucion_nombre || "Colegio Principal";

  // Estados
  const [sedes, setSedes] = useState([]);
  const [matriculas, setMatriculas] = useState([]);
  const [matriculaExistente, setMatriculaExistente] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showTabla, setShowTabla] = useState(false);
  
  const socketRef = useRef(null);
  const fotoPreviewUrlRef = useRef(null);

  const [formData, setFormData] = useState({
    documento_estudiante: '', tipo_documento: '', nombres_estudiante: '', apellidos_estudiante: '',
    fecha_nacimiento_estudiante: '', telefono_estudiante: '', eps: '', grado: '', grupo: '',
    sede_id: '', jornada: '', numero_matricula: '', codigo_anterior: '', fecha_matricula: '',
    tipo_sangre: '', direccion_estudiante: '', email_estudiante: '', estrato: '', genero: '',
    documento_padre: '', tipo_documento_padre: '', nombres_padre: '', apellidos_padre: '',
    fecha_nacimiento_padre: '', telefono1: '', telefono2: '', direccion_padre: '', ocupacion_padre: '', parentesco: ''
  });

  const [files, setFiles] = useState({
    documento_estudiante_archivo: null, documento_representante: null, sirben: null, fosyga: null,
    boletin_anterior: null, foto_estudiante: null, servicios_publicos: null, paz_y_salvo: null
  });

  // Headers con token
  const headers = useMemo(() => ({
    Authorization: `Bearer ${token}`
  }), [token]);

  /* =========================
      CARGA DE DATOS
  ========================= */

  const fetchSedes = async () => {
    try {
      const res = await axios.get(API_SEDES, { headers });
      setSedes(Array.isArray(res.data) ? res.data : res.data?.data || []);
    } catch (err) {
      console.error("Error sedes:", err);
    }
  };

  const fetchMatriculas = async (sedeId = '') => {
    try {
      setLoading(true);
      // Si sedeId es '0' o vacío, manejamos la lógica de filtro global o principal
      const url = sedeId ? `${API_BASE}?sede_id=${sedeId}` : API_BASE;
      const res = await axios.get(url, { headers });
      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
      
      const processed = data.map(m => ({
        ...m,
        sede_nombre: m.sede_id && m.sede_nombre ? m.sede_nombre : (m.tenant_nombre || tenantNombre)
      }));
      setMatriculas(processed);
    } catch (err) {
      setError('Error cargando matrículas');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) return;
    fetchSedes();
    fetchMatriculas();

    socketRef.current = io(API.replace('/api', ''), { auth: { token } });
    socketRef.current.on('nueva_matricula', fetchMatriculas);
    socketRef.current.on('eliminar_matricula', fetchMatriculas);

    return () => {
      socketRef.current?.disconnect();
      if (fotoPreviewUrlRef.current) URL.revokeObjectURL(fotoPreviewUrlRef.current);
    };
  }, [token]);

  /* =========================
      MANEJADORES
  ========================= */

  // const safeSetFormFromBackend = (data = {}) => {
  //   const est = data.estudiante || data || {};
  //   const pad = data.padre || {};
  //   setFormData({
  //     documento_estudiante: est.documento_estudiante || est.documento || '',
  //     tipo_documento: est.tipo_documento || '',
  //     nombres_estudiante: est.nombres_estudiante || est.nombres || '',
  //     apellidos_estudiante: est.apellidos_estudiante || est.apellidos || '',
  //     fecha_nacimiento_estudiante: est.fecha_nacimiento_estudiante || est.fecha_nacimiento || '',
  //     telefono_estudiante: est.telefono_estudiante || est.telefono || '',
  //     eps: est.eps || '',
  //     grado: est.grado || '',
  //     grupo: est.grupo || '',
  //     sede_id: est.sede_id !== undefined ? String(est.sede_id) : '',
  //     jornada: est.jornada || '',
  //     numero_matricula: est.numero_matricula || '',
  //     codigo_anterior: est.codigo_anterior || '',
  //     fecha_matricula: est.fecha_matricula || '',
  //     tipo_sangre: est.tipo_sangre || '',
  //     direccion_estudiante: est.direccion_estudiante || est.direccion || '',
  //     email_estudiante: est.email_estudiante || est.email || '',
  //     estrato: est.estrato || '',
  //     genero: est.genero || '',
  //     documento_padre: pad.documento_padre || pad.documento || '',
  //     tipo_documento_padre: pad.tipo_documento || '',
  //     nombres_padre: pad.nombres || pad.nombres_padre || '',
  //     apellidos_padre: pad.apellidos || pad.apellidos_padre || '',
  //     fecha_nacimiento_padre: pad.fecha_nacimiento || '',
  //     telefono1: pad.telefono1 || pad.telefono || '',
  //     telefono2: pad.telefono2 || '',
  //     direccion_padre: pad.direccion || '',
  //     ocupacion_padre: pad.ocupacion_padre || '',
  //     parentesco: pad.parentesco || ''
  //   });
  // };

  const safeSetFormFromBackend = (data = {}) => {
  const est = data.estudiante || data || {};
  const pad = data.padre || data.acudiente || {};

  setFormData({
    /* =======================
       👨‍🎓 ESTUDIANTE
    ======================= */
    documento_estudiante: est.documento_estudiante || est.documento || '',
    tipo_documento: est.tipo_documento || '',
    nombres_estudiante: est.nombres_estudiante || est.nombres || '',
    apellidos_estudiante: est.apellidos_estudiante || est.apellidos || '',
    fecha_nacimiento_estudiante: est.fecha_nacimiento_estudiante || est.fecha_nacimiento || '',
    telefono_estudiante: est.telefono_estudiante || est.telefono || '',
    eps: est.eps || '',
    grado: est.grado || '',
    grupo: est.grupo || '',
    sede_id: est.sede_id !== undefined ? String(est.sede_id) : '',
    jornada: est.jornada || '',
    numero_matricula: est.numero_matricula || '',
    codigo_anterior: est.codigo_anterior || '',
    fecha_matricula: est.fecha_matricula || '',
    tipo_sangre: est.tipo_sangre || '',
    direccion_estudiante: est.direccion_estudiante || est.direccion || '',
    email_estudiante: est.email_estudiante || est.email || '',
    estrato: est.estrato || '',
    genero: est.genero || '',

    /* =======================
       👨‍👩‍👧 ACUDIENTE / PADRE
    ======================= */
    documento_padre: pad.documento_padre || pad.documento || '',
    tipo_documento_padre: pad.tipo_documento || '',
    nombres_padre: pad.nombres || pad.nombres_padre || '',
    apellidos_padre: pad.apellidos || pad.apellidos_padre || '',
    fecha_nacimiento_padre: pad.fecha_nacimiento || '',

    // 📞 teléfonos (MEJORADO)
    telefono1: pad.telefono1 || pad.telefono || '',
    telefono2: pad.telefono2 || pad.celular || pad.telefono_secundario || '',

    direccion_padre: pad.direccion || '',
    ocupacion_padre: pad.ocupacion || pad.ocupacion_padre || '',
    parentesco: pad.parentesco || '',

    // 🆕 extras (por si luego amplías módulo)
    email_padre: pad.email || '',
    ocupacion_empresa: pad.empresa || ''
  });
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'grupo' ? value.toUpperCase().slice(0, 1) : value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files: f } = e.target;
    const file = f?.[0] || null;
    setFiles(prev => ({ ...prev, [name]: file }));
    if (name === 'foto_estudiante' && file) {
      if (fotoPreviewUrlRef.current) URL.revokeObjectURL(fotoPreviewUrlRef.current);
      fotoPreviewUrlRef.current = URL.createObjectURL(file);
    }
  };

  const handleBuscar = async () => {
    const doc = formData.documento_estudiante.trim();
    if (!doc) return setError('Ingresa un documento');
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/${doc}`, { headers });
      safeSetFormFromBackend(res.data);
      setMatriculaExistente(true);
      setMensaje('✅ Datos cargados');
    } catch {
      setMatriculaExistente(false);
      setMensaje('⚠️ No encontrado. Inicie nuevo registro.');
    } finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setMensaje('');
    setSaving(true);

    const payload = new FormData();
    Object.entries(formData).forEach(([k, v]) => payload.append(k, v || ''));
    Object.entries(files).forEach(([k, f]) => { if (f) payload.append(k, f); });

    try {
      const url = matriculaExistente ? `${API_BASE}/${formData.documento_estudiante}` : API_BASE;
      const method = matriculaExistente ? 'put' : 'post';
      await axios({ 
        method, url, data: payload, 
        headers: { ...headers, 'Content-Type': 'multipart/form-data' } 
      });
      setMensaje('✅ Guardado correctamente');
      fetchMatriculas();
    } catch (err) {
      setError(err.response?.data?.message || '❌ Error al guardar');
    } finally { setSaving(false); }
  };

  const handleEliminar = async () => {
    if (!window.confirm('¿Eliminar esta matrícula?')) return;
    try {
      await axios.delete(`${API_BASE}/${formData.documento_estudiante}`, { headers });
      setMensaje('🗑️ Eliminada');
      setMatriculaExistente(false);
      fetchMatriculas();
    } catch (err) { setError('Error al eliminar'); }
  };

  const calcularEdad = (fecha) => {
    if (!fecha) return '';
    const hoy = new Date();
    const cumple = new Date(fecha);
    let edad = hoy.getFullYear() - cumple.getFullYear();
    if (hoy.getMonth() < cumple.getMonth() || (hoy.getMonth() === cumple.getMonth() && hoy.getDate() < cumple.getDate())) edad--;
    return edad;
  };

  return (
    <div className="matricula-wrap">
      <form className="mat-form" onSubmit={handleSubmit}>
        <header className="mat-header">
          <h2>Gestión de Matrícula</h2>
          <div className="mat-actions">
            <button type="button" className="btn-primary" onClick={() => {
              setFormData({ /* campos vacíos */ });
              setMatriculaExistente(false);
              setMensaje('');
            }}>+ Nueva</button>
            <button type="button" className="btn-outline" onClick={() => setShowTabla(!showTabla)}>
              {showTabla ? 'Ocultar Lista' : 'Ver Matriculados'}
            </button>
          </div>
        </header>

        {/* BUSCADOR */}
        <div className="row">
          <label>Documento del estudiante</label>
          <div className="row-inline">
            <input name="documento_estudiante" value={formData.documento_estudiante} onChange={handleChange} placeholder="Buscar por documento..." />
            <button type="button" className="btn-search" onClick={handleBuscar} disabled={loading}>Buscar</button>
          </div>
        </div>

        {/* SECCION ESTUDIANTE */}
        <div className="row grid-3">
          <div><label>Nombres</label><input name="nombres_estudiante" value={formData.nombres_estudiante} onChange={handleChange} /></div>
          <div><label>Apellidos</label><input name="apellidos_estudiante" value={formData.apellidos_estudiante} onChange={handleChange} /></div>
          <div>
            <label>Tipo Doc.</label>
            <select name="tipo_documento" value={formData.tipo_documento} onChange={handleChange}>
              <option value="">Seleccione</option>
              {TIPO_DOCUMENTO_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
            </select>
          </div>
        </div>

        <div className="row grid-3">
          <div>
            <label>Nacimiento</label>
            <input type="date" name="fecha_nacimiento_estudiante" value={formData.fecha_nacimiento_estudiante} onChange={handleChange} />
            <small>Edad: {calcularEdad(formData.fecha_nacimiento_estudiante)} años</small>
          </div>
          <div><label>Teléfono</label><input name="telefono_estudiante" value={formData.telefono_estudiante} onChange={handleChange} /></div>
          <div><label>EPS</label><input name="eps" value={formData.eps} onChange={handleChange} /></div>
        </div>

        <div className="row grid-3">
          <div><label>Dirección</label><input name="direccion_estudiante" value={formData.direccion_estudiante} onChange={handleChange} /></div>
          <div><label>Estrato</label>
            <select name="estrato" value={formData.estrato} onChange={handleChange}>
              <option value="">-</option>
              {ESTRATO_OPTIONS.map(e => <option key={e} value={e}>{e}</option>)}
            </select>
          </div>
          <div><label>Género</label>
            <select name="genero" value={formData.genero} onChange={handleChange}>
              <option value="">-</option>
              {GENERO_OPTIONS.map(g => <option key={g} value={g}>{g}</option>)}
            </select>
          </div>
        </div>

        {/* ACADEMICO */}
        <div className="row grid-3">
          <div>
            <label>Grado</label>
            <select name="grado" value={formData.grado} onChange={handleChange}>
              <option value="">Seleccione</option>
              {[0,1,2,3,4,5,6,7,8,9,10,11].map(g => <option key={g} value={g}>{g === 0 ? 'Transición' : `${g}°`}</option>)}
            </select>
          </div>
          <div><label>Grupo</label><input name="grupo" value={formData.grupo} onChange={handleChange} maxLength={1} placeholder="A, B, C..." /></div>
          <div>
            <label>Sede</label>
            <select name="sede_id" value={formData.sede_id} onChange={handleChange}>
              <option value="0">{tenantNombre} (Principal)</option>
              {sedes.map(s => <option key={s.id} value={String(s.id)}>{s.nombre}</option>)}
            </select>
          </div>
        </div>

        <div className="row grid-3">
          <div><label>Jornada</label>
            <select name="jornada" value={formData.jornada} onChange={handleChange}>
              <option value="">-</option>
              {JORNADAS.map(j => <option key={j} value={j}>{j}</option>)}
            </select>
          </div>
          <div><label>Código Ant.</label><input name="codigo_anterior" value={formData.codigo_anterior} onChange={handleChange} /></div>
          <div><label>Núm. Matrícula</label><input name="numero_matricula" value={formData.numero_matricula} onChange={handleChange} /></div>
        </div>

        {/* ARCHIVOS */}
        <div className="archivos-grid">
          <div className="file-input">
            <label>Doc. Estudiante</label>
            <input type="file" name="documento_estudiante_archivo" onChange={handleFileChange} />
          </div>
          <div className="file-input">
            <label>Foto Estudiante</label>
            <input type="file" name="foto_estudiante" onChange={handleFileChange} />
            {fotoPreviewUrlRef.current && <img src={fotoPreviewUrlRef.current} alt="preview" className="mini-preview" />}
          </div>
          <div className="file-input">
            <label>Doc. Acudiente</label>
            <input type="file" name="documento_representante" onChange={handleFileChange} />
          </div>
          <div className="file-input">
            <label>Boletín</label>
            <input type="file" name="boletin_anterior" onChange={handleFileChange} />
          </div>
        </div>

        {/* ACUDIENTE */}
      {/* ACUDIENTE */}
<h3 className="section-title">Datos del Acudiente</h3>

<div className="row grid-3">
  <div>
    <label>Tipo Documento</label>
    <select
      name="tipo_documento_padre"
      value={formData.tipo_documento_padre}
      onChange={handleChange}
    >
      <option value="">Seleccione</option>
      {TIPO_DOCUMENTO_OPTIONS.map(o => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  </div>

  <div>
    <label>Documento</label>
    <input
      name="documento_padre"
      value={formData.documento_padre}
      onChange={handleChange}
      placeholder="Número de documento"
    />
  </div>

  <div>
    <label>Parentesco</label>
    <input
      name="parentesco"
      value={formData.parentesco}
      onChange={handleChange}
      placeholder="Ej: Padre, Madre, Tío..."
    />
  </div>
</div>

<div className="row grid-3">
  <div>
    <label>Nombres</label>
    <input
      name="nombres_padre"
      value={formData.nombres_padre}
      onChange={handleChange}
    />
  </div>

  <div>
    <label>Apellidos</label>
    <input
      name="apellidos_padre"
      value={formData.apellidos_padre}
      onChange={handleChange}
    />
  </div>

  <div>
    <label>Ocupación</label>
    <input
      name="ocupacion_padre"
      value={formData.ocupacion_padre}
      onChange={handleChange}
      placeholder="Ej: Comerciante, Docente..."
    />
  </div>
</div>

<div className="row grid-3">
  <div>
    <label>Teléfono 1</label>
    <input
      name="telefono1"
      value={formData.telefono1}
      onChange={handleChange}
    />
  </div>

  <div>
    <label>Teléfono 2</label>
    <input
      name="telefono2"
      value={formData.telefono2}
      onChange={handleChange}
    />
  </div>

  <div>
    <label>Dirección</label>
    <input
      name="direccion_padre"
      value={formData.direccion_padre}
      onChange={handleChange}
    />
  </div>
</div>

<div className="row grid-2">
  <div>
    <label>Correo (opcional)</label>
    <input
      name="email_padre"
      value={formData.email_padre || ""}
      onChange={handleChange}
      placeholder="correo@ejemplo.com"
    />
  </div>

  <div>
    <label>Contacto de emergencia</label>
    <input
      name="contacto_emergencia"
      value={formData.contacto_emergencia || ""}
      onChange={handleChange}
      placeholder="Nombre y teléfono"
    />
  </div>


        </div>

        {error && <div className="alert error">{error}</div>}
        {mensaje && <div className="alert success">{mensaje}</div>}

        <div className="form-footer">
          <button type="submit" className="btn-save" disabled={saving}>
            {saving ? 'Guardando...' : (matriculaExistente ? 'Actualizar' : 'Registrar')}
          </button>
          {matriculaExistente && (
            <button type="button" className="btn-danger" onClick={handleEliminar}>Eliminar</button>
          )}
        </div>
      </form>

      {/* LISTADO */}
      {showTabla && (
        <div className="tabla-container fade-in">
          <h3>Estudiantes en Sistema ({matriculas.length})</h3>
          <div className="table-scroll">
            <table>
              <thead>
                <tr>
                  <th>Documento</th>
                  <th>Estudiante</th>
                  <th>Grado</th>
                  <th>Sede</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {matriculas.map((m, i) => (
                  <tr key={i}>
                    <td>{m.documento_estudiante}</td>
                    <td>{m.nombres_estudiante} {m.apellidos_estudiante}</td>
                    <td>{m.grado}°{m.grupo}</td>
                    <td><small>{m.sede_nombre}</small></td>
                    <td>
                      <button className="btn-edit" onClick={() => {
                        safeSetFormFromBackend(m);
                        setMatriculaExistente(true);
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }}>Editar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default MatriculaForm;